import React from 'react'
import Questions from '../../Editor/Questions'
import { Course } from '../../Course/types'
import { FlexRow } from '../../FlexboxReusables/FlexItems'
import { Typography } from 'antd'
import LoadingSpinner from '../../LoadingSpinner'
import { FormattedMessage } from 'react-intl'

type ReviewQuestionsProps = {
  course: Course | undefined
}

const ReviewQuestions: React.FC<ReviewQuestionsProps> = ({ course }) => {
  if (!course) {
    return <LoadingSpinner />
  }

  return (
    <>
      <FlexRow>
        <Typography.Title level={2} style={{ textDecoration: 'underline' }}>
          <FormattedMessage id='course.doubleCheckAllQuestions' />
        </Typography.Title>
      </FlexRow>
      <Questions course={course} isReviewMode />
    </>
  )
}

export default ReviewQuestions